'use client';

import NextImageView from '@/components/ui/NextImageView/NextImageView';
import { getImageLayoutSizes } from '@/utils/nextImage';
import styles from './MaterialDetailImage.module.scss';

type MaterialDetailImageProps = {
  src: string;
  alt: string;
  /** 画像タップで拡大表示する */
  onImageClick: () => void;
  priority?: boolean;
};

/**
 * コマ詳細モーダルのコマ画像。
 * NEWバッジ・お気に入りボタンは画像の外にはみ出して置くため、スライダーの外側（親）が描画する。
 * ここはスライドに収まる画像だけを持ち、状態は持たない presentational。
 */
function MaterialDetailImage({ src, alt, onImageClick, priority = false }: MaterialDetailImageProps) {
  return (
    <div className={styles.imageWrapper}>
      <button type='button' className={styles.zoomButton} onClick={onImageClick} aria-label='画像を拡大'>
        <NextImageView
          src={src}
          alt={alt}
          fill
          sizes={getImageLayoutSizes({ sp: '100vw', pc: '400px' })}
          objectFit='contain'
          priority={priority}
        />
      </button>
    </div>
  );
}

export default MaterialDetailImage;
